import React, { FunctionComponent } from 'react';

import { WithTooltip } from '@modules/shared/components';
import { Product } from '@modules/products/models';

import './ProductCard.scss';

interface Props {
    product: Product;
}

export const ProductCard: FunctionComponent<Props> = ({ product }: Props) => {
    const description =
        product?.description?.length > 275 ? product.description.slice(0, 276) + '...' : product.description;
    return (
        <div className="product-card">
            <div>
                <div className="product-card__header">
                    <WithTooltip content={product.name} />
                </div>
                <div className="product-card__body">{description}</div>
            </div>
            <div className="product-card__footer">
                <a
                    href={product.userManualUrl}
                    rel="noreferrer nofollow noopener"
                    target="_blank"
                    className={`product-card__url ${!product.userManualUrl && 'disabled'}`}
                >
                    <i className={`icon icon-about`} />
                    <span>User manual</span>
                </a>
                <a
                    href={product.homeUrl}
                    rel="noreferrer nofollow noopener"
                    target="_blank"
                    className={`product-card__url ${!product.homeUrl && 'disabled'}`}
                >
                    <span className="margin-right">Go to product</span>
                    <i className="icon icon-arrow-right" />
                </a>
            </div>
        </div>
    );
};
